module.exports = __webpack_public_path__ + "static/vpn-98f623cecd980bb6922a2677c072da37.png";